import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const Rockset = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="Rockset"
    height={height}
    width={width}
    title="Rockset logo"
    titleId="rockset-logo-title"
    viewBox="0 0 512 512"
    {...props}
  >
    <g>
      <path
        d="M350.6,214.3c0-43.6-30.2-75.7-79.6-75.7H160.1v234.7h50.3v-84.2h36.9l46.6,84.2h57.9   L298.5,284C324.3,278.1,350.6,255.8,350.6,214.3z"
        fill="#5D2784"
      />
      <path d="M149.3,51.6V0H0v512h149.3v-51.6H49.7V51.6H149.3z" fill="#65C0DD" id="ekwUMopc7yf8" />
      <path d="M362.7,51.6V0H512v512H362.7v-51.6h99.6V51.9L362.7,51.6z" fill="#65C0DD" />
    </g>
  </SvgIcon>
);
